const navbarCollapseEl = document.querySelector('.navbar');
const mainMenuEl = document.querySelector('#menu--primary')
const megaMenu = document.querySelector('.dropdown--mega');
const featuredCards = document.querySelector('.featured__practiced-areas');
const bodyEl = document.body;
const backButtons = document.querySelectorAll('.submenu__back .btn--back');
const dropdownToggles = document.querySelectorAll('.depth_0 .dropdown-toggle, .depth_1 .dropdown-toggle');

/**
 * Adds body overlay when mega menu or menu dropdown are active
 */
mainMenuEl.addEventListener('mouseenter', function() {
    bodyEl.classList.add('navigation--overlayed');
});
mainMenuEl.addEventListener('mouseleave', function() {
    bodyEl.classList.remove('navigation--overlayed');
});

/**
 * Sets default height to mega menu for animation
 */
const computedStyle = window.getComputedStyle(megaMenu);
const computedDefaultHeight = computedStyle.getPropertyValue('--mega-menu--height').trim();

console.log(computedDefaultHeight);

// Add event listener for when the navbar has been fully shown
navbarCollapseEl.addEventListener('shown.bs.collapse', function () {
    bodyEl.classList.toggle('navigation--open');
    navbarCollapseEl.classList.add('open');
});

// Add event listener for when the navbar starts to be hidden
navbarCollapseEl.addEventListener('hidden.bs.collapse', function () {
    bodyEl.classList.toggle('navigation--open');
    navbarCollapseEl.classList.remove('open');
});

/**
 * Allows second third teir navigation levels in the navbar
 * Sets calculated height to mega menu for animation
 */
dropdownToggles.forEach( (toggle) => {
    toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

      
        $(this).closest('.dropdown').toggleClass('show');
        $(this).next('.dropdown-menu').toggleClass('show');
    });

    toggle.addEventListener('shown.bs.dropdown', function (event) {
        const menu = event.target.nextElementSibling;
        const menuHeight = menu.scrollHeight + 24;
        
        if (menuHeight > parseInt(computedDefaultHeight)) {
            megaMenu.style.setProperty('--mega-menu--height', `${menuHeight}px`);
        } else {
            megaMenu.style.setProperty('--mega-menu--height', computedDefaultHeight);
        }
    });
});

/**
 * Sets default height to mega menu when subnav is closed for animation
 */
backButtons.forEach((button) => {
    button.addEventListener('click', function (event) {
        const menu = event.target.closest('ul');

        megaMenu.style.setProperty('--mega-menu--height', computedDefaultHeight);
    });
});


function handleBsToggle() {
  const dropdowns = document.querySelectorAll('#menu--primary > li > .dropdown-toggle');

  if (window.innerWidth >= 992) {
    dropdowns.forEach( (toggle) => { toggle.removeAttribute('data-bs-toggle'); });
  } else {
    dropdowns.forEach( (toggle) => { toggle.setAttribute('data-bs-toggle', 'dropdown'); });
  }
}

document.querySelectorAll('#menu--primary .dropdown-menu a').forEach(link => {
  link.addEventListener('click', function (e) {
    e.stopPropagation();
  });
});

window.addEventListener('load', handleBsToggle);
window.addEventListener('resize', handleBsToggle);
